import React from "react"

import InputTextElement from "./InputTextElement";
import { useFormatter } from "../../utils";
import dayjs from 'dayjs'

const InputDateControl = ({
    editing,
    required,
    name,
    label,
    autoFocus,
    placeholder,
    type = "text",
    hint,
    icon,
    haserror,
    disabled,
    readonly,
    mindate,
    maxdate,
    className = "",
    watchfunction = null,
    mirrorField = null,
    value,
    onChange,
    error,
}) => {
    const { formatDatetimeForInput } = useFormatter();

    if (!editing) readonly = true;

    const slotProps = {
        input: {
            min: mindate,
            max: maxdate,
        },
    };
    const computedClassName =
        typeof value === typeof undefined
            ? className.replace(" filled", "").replace(" empty", "") + " empty"
            : className.replace(" filled", "").replace(" empty", "") + " filled";

    return (
        <InputTextElement
            id={name}
            name={name}
            value={type === "datetime" ? formatDatetimeForInput(value) : value && dayjs(value)}
            type={type === "datetime" ? "datetime-local" : type}
            label={label}
            placeholder={placeholder}
            icon={icon}
            hint={hint}
            error={error}
            invalid={Boolean(error) || haserror}
            editing={editing}
            required={required}
            autoFocus={autoFocus}
            disabled={disabled}
            readonly={readonly}
            className={computedClassName}
            onChange={onChange}
            slotProps={slotProps}
            watchfunction={watchfunction}
            mirrorField={mirrorField}
        />
    );
};

export default InputDateControl;
